import { defineComponent as _defineComponent } from 'vue'
import { useAppStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanaryMarker',
  setup(__props) {

const { xServeTrack } = useAppStore();

const canaryMarker = computed(() => {
	const envCanary = JW_CONFIG.PR_CANARY_FLAG;
	if (envCanary) return envCanary.replaceAll('-', ' ');

	if (xServeTrack.value == null || xServeTrack.value === 'prod' || xServeTrack.value === 'canary-public') return null;

	return xServeTrack.value.replaceAll('-', ' ');
});

const isPrCanary = JW_CONFIG.PR_CANARY_FLAG != null;

function exitPrCanary() {
	const url = new URL(window.location.href);
	url.searchParams.set('exit-pr-canary', 'true');
	url.searchParams.delete('pr-canary');
	window.location.href = url.toString();
}

return { __sfc: true,xServeTrack, canaryMarker, isPrCanary, exitPrCanary }
}

})